// src/components/CameraConfig.js
import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { Form, Row, Col } from "react-bootstrap";
import BackButton from "../../../../components/UI_Kit/BackButton/BackButton";
import DropdownComponent from "../../../../components/UI_Kit/Dropdown/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../styles.css";
// Remove location from props, use onSave and initialCameras directly
const CameraConfig = ({ onSave, initialCameras = [] }) => {
  // Initialize state directly from initialCameras prop
  const [cameras, setCameras] = useState(
    initialCameras.length > 0
      ? initialCameras
      : [{ id: 1, role: "", name: "", viewingArea: "" }] // Default if empty
  );
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    async function fetchRoles() {
      try {
        const response = await api.get("/prices");
        let constitutionPointItem = response.data.find(item => item.type === "Constitution du point");
        if (constitutionPointItem && constitutionPointItem.champ && constitutionPointItem.champ[0].choix) {
          setRoleOptions(constitutionPointItem.champ[0].choix.map(opt => opt.titre));
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    }
    fetchRoles();
  }, []);

  const handleSave = () => {
    // Validate all camera fields before saving
    for (const camera of cameras) {
      if (!camera.role) {
        toast.error(`Veuillez sélectionner un rôle pour la caméra ${camera.id}.`);
        return;
      }
      if (!camera.name.trim()) {
        toast.error(`Veuillez entrer un nom pour la caméra ${camera.id}.`);
        return;
      }
      if (!camera.viewingArea.trim()) {
        toast.error(`Veuillez décrire la zone à visionner pour la caméra ${camera.id}.`);
        return;
      }
    }
    // Call the onSave prop passed from EditPoint with the current camera state
    onSave(cameras);
  };

  const handleCameraChange = (cameraId, field, value) => {
    setCameras((prev) =>
      prev.map((cam) =>
        cam.id === cameraId ? { ...cam, [field]: value } : cam
      )
    );
  };

  const addCamera = () => {
    if (cameras.length < 30) {
      const newId = Math.max(...cameras.map(c => c.id)) + 1;
      setCameras([...cameras, { id: newId, role: "", name: "", viewingArea: "" }]);
    }
  };

  const deleteCamera = (cameraId) => {
    if (cameras.length > 1) {
      setCameras(cameras.filter(cam => cam.id !== cameraId));
    }
  };

  return (
    <>
      <ToastContainer />
      {/* Header section with back button and title */}
      <div className="header mb-4 d-flex align-items-center">
        <BackButton className="back-button" />
        <span className="step-title">Point de vision</span>
      </div>
      <p className="form-title pb-1">Constitution du point</p>

      {cameras.map((camera) => (
        <div key={camera.id} className="camera-section mb-4 p-3  rounded">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Caméra {camera.id}</h6>
            {cameras.length > 1 && (
              <img
                onClick={() => deleteCamera(camera.id)}
                src="/Cross.png"
                alt="Delete camera"
                className="delete-camera-button"
              >
              </img>
            )}
          </div>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId={`cameraRole${camera.id}`}>
                <Form.Label>Rôle de la caméra *</Form.Label>
                <DropdownComponent
                  name="role"
                  value={camera.role}
                  onChange={(e) => handleCameraChange(camera.id, "role", e.target.value)}
                  options={roleOptions.map(role => ({ label: role, value: role }))}
                  placeholder="Sélectionner..."
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId={`cameraName${camera.id}`}>
                <Form.Label>Nom de la caméra *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Nommer la caméra"
                  value={camera.name}
                  onChange={(e) =>
                    handleCameraChange(camera.id, "name", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId={`viewingArea${camera.id}`}>
                <Form.Label>Zone à visionner *</Form.Label>
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    as="textarea"
                    name="viewingArea"
                    placeholder="Ajouter un commentaire..."
                    value={camera.viewingArea}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 300) {
                        handleCameraChange(camera.id, "viewingArea", value);
                      }
                    }}
                    required
                    maxLength={300}
                    className="comment-box"
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 8,
                    right: 7,
                    background: 'rgba(255,255,255,0.8)',
                    padding: '0 6px',
                    fontSize: '16px',
                    color: '#888',
                    pointerEvents: 'none'
                  }}>
                    <small>{camera.viewingArea.length}/300</small>
                  </div>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}

      {cameras.length < 30 && (
        <div className="add-camera-button mb-4">
          <span variant="success" onClick={addCamera}>
            <img src="/plus.png" alt="Add camera"></img> Ajouter une caméra
          </span>
        </div>
      )}

      <div className="footer shadow-lg d-flex justify-content-center">
        <button
          className="w-100 primary-button primary-button-block"
          type="submit"
          onClick={handleSave}
        >
          Valider
        </button>
      </div>
    </>
  );
};

export default CameraConfig;
